<div>
    <div class="gate d-flex flex-column gap-2 my-3">
        {{ this.session }}
    </div>
    @for (load of loading | keyvalue; track load.key) {
        <alert type="info"> {{ load.value }} </alert>
    }
    @if (!unlocked) {
        <div class="gate d-flex flex-column gap-2" role="group" [attr.aria-labelledby]="gateLabelId">
            <label [id]="gateLabelId" [for]="gateInputId" translate="PACESPECTOR_GATE_LABEL"></label>
            <input
                [id]="gateInputId"
                [placeholder]="'PACESPECTOR_GATE_LABEL' | translate"
                [(ngModel)]="accessCode"
                name="accessCode"
                [attr.aria-invalid]="'true'"
                (keyup)="unlock()"
                autocomplete="one-time-code"
            />
        </div>
    } @else {
        <alert type="warning">{{ 'PACESPECTOR_ALERT_MSG' | translate }}</alert>
        <tabset>
            <tab heading="Addresses">
                <div class="d-flex flex-column gap-2 my-3">
                    @if (addresses$ | async; as addresses) {
                        <span>
                            Last stored:
                            <time [attr.datetime]="addresses.timestamp.toISOString()" class="addresses__lastsync">
                                {{ addresses.timestamp.toISOString() }}
                            </time>
                        </span>
                        <pace-core-address-spector
                            [addresses]="addresses.data"
                            (deleteLocal)="deleteAddresses()"
                            (downloadJson)="this.downloadJson($event)"
                        ></pace-core-address-spector>
                    } @else {
                        no addresses stored
                    }
                </div>
            </tab>
            <tab heading="Current Timesheet">
                <div class="d-flex flex-column gap-2 my-3">
                    @if (currentTimesheet$ | async; as currentTimesheet) {
                        <span>
                            Last stored:
                            <time
                                [attr.datetime]="currentTimesheet.timestamp?.toString()"
                                class="addresses__lastsync"
                                >{{ currentTimesheet.timestamp?.toString() }}</time
                            >
                        </span>
                        <pace-core-timesheet-spector
                            [model]="currentTimesheet.value"
                            (resetLocal)="this.resetTimesheet(TIMESHEET_KEYS.CURRENT_TIMESHEET)"
                            (downloadJson)="this.downloadJson($event)"
                        ></pace-core-timesheet-spector>
                    } @else {
                        no current timesheet
                    }
                </div>
            </tab>
            <tab heading="Submitted Timesheet">
                <div class="d-flex flex-column gap-2 my-3">
                    @if (submittedTimesheet$ | async; as submittedTimesheet) {
                        <span>
                            Last stored:
                            <time
                                [attr.datetime]="submittedTimesheet.timestamp?.toString()"
                                class="addresses__lastsync"
                            >
                                {{ submittedTimesheet.timestamp?.toString() }}
                            </time>
                        </span>
                        <pace-core-timesheet-spector
                            [model]="submittedTimesheet.value"
                            (resetLocal)="this.resetTimesheet(TIMESHEET_KEYS.SUBMITTED_TIMESHEET)"
                            (downloadJson)="this.downloadJson($event)"
                        ></pace-core-timesheet-spector>
                    } @else {
                        no timesheet submitted
                    }
                </div>
            </tab>
        </tabset>
    }
</div>
